<template>
  <div>
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col w-3/4 sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-2/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="">
            <div class="p-4">
              <LogoRed class="w-32 mt-1 mb-1 mr-0 fill-current text-primary" />
              <h1>
                <span> Events starts here </span>
                <span> 🚀 </span>
              </h1>
              <div style="font-size: 0.75rem; color: #aaa">
                Make your events management easy and fun!
              </div>
              <br />
              <div>
                <div style="font-size: 0.7rem">Email</div>
                <div>
                  <vs-input
                    v-validate="{ regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }"
                    name="email"
                    class="w-full"
                    v-model="form.email"
                    :maxLength="254"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('email')"
                  >
                    {{ errors.first("email") }}
                  </span>
                </div>
              </div>
              <br />
              <div>
                <div style="font-size: 0.7rem">Password</div>
                <div>
                  <vs-input
                    type="password"
                    name="password"
                    class="w-full"
                    v-model="form.password"
                    :maxLength="254"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password')"
                  >
                    {{ errors.first("password") }}
                  </span>
                </div>
              </div>
              <div>
                <vs-button to="/onboarding/create-seller" class="mt-6 w-full">Register</vs-button>
              </div>
              <br />
              <div class="text-center" style="color: #aaa">
                Already have an account?
                <a to="/login" style="color: #ff0813">Sign in</a>
              </div>
              <br>
              <svg
                width="100%"
                height="21"
                viewBox="0 0 400 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="10.0859" x2="167" y2="10.0859" stroke="#ECE7E7" />
                <path
                  d="M197.108 15.7029C196.441 15.7029 195.834 15.5513 195.288 15.2479C194.751 14.9446 194.326 14.5156 194.014 13.9609C193.711 13.3976 193.559 12.7476 193.559 12.0109C193.559 11.2829 193.715 10.6416 194.027 10.0869C194.348 9.5236 194.781 9.0946 195.327 8.79994C195.873 8.4966 196.484 8.34494 197.16 8.34494C197.836 8.34494 198.447 8.4966 198.993 8.79994C199.539 9.0946 199.968 9.51927 200.28 10.0739C200.601 10.6286 200.761 11.2743 200.761 12.0109C200.761 12.7476 200.596 13.3976 200.267 13.9609C199.946 14.5156 199.509 14.9446 198.954 15.2479C198.399 15.5513 197.784 15.7029 197.108 15.7029ZM197.108 14.6629C197.533 14.6629 197.931 14.5633 198.304 14.3639C198.677 14.1646 198.976 13.8656 199.201 13.4669C199.435 13.0683 199.552 12.5829 199.552 12.0109C199.552 11.4389 199.439 10.9536 199.214 10.5549C198.989 10.1563 198.694 9.8616 198.33 9.67094C197.966 9.4716 197.572 9.37194 197.147 9.37194C196.714 9.37194 196.315 9.4716 195.951 9.67094C195.596 9.8616 195.31 10.1563 195.093 10.5549C194.876 10.9536 194.768 11.4389 194.768 12.0109C194.768 12.5916 194.872 13.0813 195.08 13.4799C195.297 13.8786 195.583 14.1776 195.938 14.3769C196.293 14.5676 196.683 14.6629 197.108 14.6629ZM203.499 9.61894C203.707 9.2116 204.002 8.89527 204.383 8.66994C204.773 8.4446 205.246 8.33194 205.8 8.33194V9.55394H205.488C204.162 9.55394 203.499 10.2733 203.499 11.7119V15.5859H202.316V8.46194H203.499V9.61894Z"
                  fill="#4B465C"
                />
                <path
                  d="M197.108 15.7029C196.441 15.7029 195.834 15.5513 195.288 15.2479C194.751 14.9446 194.326 14.5156 194.014 13.9609C193.711 13.3976 193.559 12.7476 193.559 12.0109C193.559 11.2829 193.715 10.6416 194.027 10.0869C194.348 9.5236 194.781 9.0946 195.327 8.79994C195.873 8.4966 196.484 8.34494 197.16 8.34494C197.836 8.34494 198.447 8.4966 198.993 8.79994C199.539 9.0946 199.968 9.51927 200.28 10.0739C200.601 10.6286 200.761 11.2743 200.761 12.0109C200.761 12.7476 200.596 13.3976 200.267 13.9609C199.946 14.5156 199.509 14.9446 198.954 15.2479C198.399 15.5513 197.784 15.7029 197.108 15.7029ZM197.108 14.6629C197.533 14.6629 197.931 14.5633 198.304 14.3639C198.677 14.1646 198.976 13.8656 199.201 13.4669C199.435 13.0683 199.552 12.5829 199.552 12.0109C199.552 11.4389 199.439 10.9536 199.214 10.5549C198.989 10.1563 198.694 9.8616 198.33 9.67094C197.966 9.4716 197.572 9.37194 197.147 9.37194C196.714 9.37194 196.315 9.4716 195.951 9.67094C195.596 9.8616 195.31 10.1563 195.093 10.5549C194.876 10.9536 194.768 11.4389 194.768 12.0109C194.768 12.5916 194.872 13.0813 195.08 13.4799C195.297 13.8786 195.583 14.1776 195.938 14.3769C196.293 14.5676 196.683 14.6629 197.108 14.6629ZM203.499 9.61894C203.707 9.2116 204.002 8.89527 204.383 8.66994C204.773 8.4446 205.246 8.33194 205.8 8.33194V9.55394H205.488C204.162 9.55394 203.499 10.2733 203.499 11.7119V15.5859H202.316V8.46194H203.499V9.61894Z"
                  fill="white"
                  fill-opacity="0.5"
                />
                <line
                  x1="233"
                  y1="10.0859"
                  x2="400"
                  y2="10.0859"
                  stroke="#ECE7E7"
                />
              </svg>
              <br>
              <br>
              <div>
                <FBBtn/>
              </div>
              <br>
              <div>
                <GoogleBtn/>
              </div>
            </div>
          </div>
        </vx-card>

        <!-- <div>Mode : {{ mode }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
//import Service from "../../services";
import LogoRed from "../../../layouts/components/LogoRed.vue";
import FBBtn from "../../../layouts/components/FBBtn.vue";
import GoogleBtn from "../../../layouts/components/GoogleBtn.vue";

export default {
  components: { LogoRed,FBBtn,GoogleBtn },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      checkbox_remember_me: false,
      mode: "Development",
    };
  },
  created() {
    if (process.env.VUE_APP_ENV != "development") {
      this.mode = "Production";
    }
  },
  methods: {
    login() {
      //console.log("login");
      let data = {
        email: this.email,
        password: this.password,
        redirect: getParamFromLink("redirectURL") ? true : null,
      };

      this.$vs.loading();

      this.$store
        .dispatch("Auth/login", data)
        .then((loginRes) => {
          if (data.redirect) {
            // redirect to check-in page
            window.location.href = `https://ascriptlab.com/soldd-out?token=${loginRes.data.redirect_token}`;
          }
          this.$store.dispatch("Auth/setUser").then((res) => {
            let s = res.default.s;
            let e = res.default.e;
            let name = res.info.name;

            if (s == null || e == null) {
              this.$router.push("/profile/selectAssets");
              this.$vs.loading.close();
              return;
            }

            this.$store.dispatch("Utility/setMerchant", s).then((res) => {
              this.$store.dispatch("Utility/setEvent", e).then((res) => {
                this.$store.dispatch("updateUserInfo", { displayName: name });
                this.$store.dispatch("Event/setMyEvents").then((event) => {
                  setTimeout(() => {
                    this.$vs.loading.close();
                    this.$router.push("/dash");
                  }, 1000);
                });
                return;
              });
            });

            return;
          });
        })
        .catch((err) => {
          this.$vs.loading.close();

          this.$vs.notify({
            title: "Oops!",
            text: "Email or Password not correct.",
            color: "danger",
          });
        });
      /*
      Service.Auth.login(data).then(res => {
        console.log(res.data);
        if (res.data.success) {
          this.$store.dispatch("Auth/setUser");
        }
      });
      */
    },
  },
};

function getParamFromLink(data) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(data);
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>
